<template>
  <b-modal
    :id="`modal-branch-bulletin-edit-${branchData.branchId}`"
    :title="
      this.$t('menu.settings.alertsNewsletters.ruleBranch', {
        branchDataName: `${branchData.name}`,
      })
    "
    size="xl"
    ok-only
    :ok-title="`${this.$t('menu.settings.alertsNewsletters.close')}`"
  >
    <div class="col-12 mb-3">
      <idx-card :title="`${this.$t('menu.settings.alertsNewsletters.diary')}`">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label
                >{{
                  $t('menu.settings.alertsNewsletters.labels.email')
                }}:</label
              >
              <div class="input-area">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="`${this.$t(
                    'menu.settings.alertsNewsletters.placeholderEmail',
                  )}`"
                  v-model="dailyInput"
                  @keyup.enter="registerEmail('daily', dailyInput, dailyInput)"
                />
                <button
                  @click="registerEmail('daily', dailyInput, dailyInput)"
                  class="btn btn-primary"
                >
                  <font-awesome-icon :icon="['fas', 'plus']" />
                </button>
              </div>
              <div class="invalid-feedback">
                {{ $t('menu.settings.alertsNewsletters.feedbackEmailUser') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="dailyLoading" class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
            <div v-else class="chips-columns">
              <div v-if="false">
                <span style="font-style: italic;">{{
                  $t('menu.settings.alertsNewsletters.none')
                }}</span>
              </div>
              <div v-for="(email, i) in dailyEmails" :key="i">
                <div ref="chip" class="chip">
                  {{ email }}
                  <span @click="remove('daily', email)" class="closebtn"
                    >&times;</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </idx-card>
    </div>
    <div class="col-12 mb-3">
      <idx-card :title="`${this.$t('menu.settings.alertsNewsletters.weekly')}`">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label
                >{{
                  $t('menu.settings.alertsNewsletters.labels.email')
                }}:</label
              >
              <div class="input-area">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="`${this.$t(
                    'menu.settings.alertsNewsletters.placeholderEmail',
                  )}`"
                  v-model="weeklyInput"
                  @keyup.enter="
                    registerEmail('weekly', weeklyInput, weeklyInput)
                  "
                />
                <button
                  @click="registerEmail('weekly', weeklyInput, weeklyInput)"
                  class="btn btn-primary"
                >
                  <font-awesome-icon :icon="['fas', 'plus']" />
                </button>
              </div>
              <div class="invalid-feedback">
                {{ $t('menu.settings.alertsNewsletters.feedbackEmailUser') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="weeklyLoading" class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
            <div v-else class="chips-columns">
              <div v-if="false">
                <span style="font-style: italic;">{{
                  $t('menu.settings.alertsNewsletters.none')
                }}</span>
              </div>
              <div v-for="(email, i) in weeklyEmails" :key="i">
                <div ref="chip" class="chip">
                  {{ email }}
                  <span @click="remove('weekly', email)" class="closebtn"
                    >&times;</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </idx-card>
    </div>
    <div class="col-12 mb-3">
      <idx-card
        :title="`${this.$t('menu.settings.alertsNewsletters.monthly')}`"
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label
                >{{
                  $t('menu.settings.alertsNewsletters.labels.email')
                }}:</label
              >
              <div class="input-area">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="`${this.$t(
                    'menu.settings.alertsNewsletters.placeholderEmail',
                  )}`"
                  v-model="monthlyInput"
                  @keyup.enter="
                    registerEmail('monthly', monthlyInput, monthlyInput)
                  "
                />
                <button
                  @click="registerEmail('monthly', monthlyInput, monthlyInput)"
                  class="btn btn-primary"
                >
                  <font-awesome-icon :icon="['fas', 'plus']" />
                </button>
              </div>
              <div class="invalid-feedback">
                {{ $t('menu.settings.alertsNewsletters.feedbackEmailUser') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="monthlyLoading" class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
            <div v-else class="chips-columns">
              <div v-if="false">
                <span style="font-style: italic;">{{
                  $t('menu.settings.alertsNewsletters.none')
                }}</span>
              </div>
              <div v-for="(email, i) in monthlyEmails" :key="i">
                <div ref="chip" class="chip">
                  {{ email }}
                  <span @click="remove('monthly', email)" class="closebtn"
                    >&times;</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </idx-card>
    </div>
    <!--
    <div class="col-12 mb-3">
      <idx-card title="ANUAL">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>E-mail:</label>
              <div class="input-area">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o e-mail"
                  v-model="annuallyInput"
                  @keyup.enter="
                    registerEmail('annually', annuallyInput, annuallyInput)
                  "
                />
                <button
                  @click="
                    registerEmail('annually', annuallyInput, annuallyInput)
                  "
                  class="btn btn-primary"
                >
                  <font-awesome-icon :icon="['fas', 'plus']" />
                </button>
              </div>
              <div class="invalid-feedback">
                Por favor, informe o e-mail do usuário.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="annuallyLoading" class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
            <div v-else class="chips-columns">
              <div v-if="false">
                <span style="font-style: italic;">Nenhum</span>
              </div>
              <div v-for="(email, i) in annuallyEmails" :key="i">
                <div ref="chip" class="chip">
                  {{ email }}
                  <span @click="remove('annually', email)" class="closebtn"
                    >&times;</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </idx-card>
    </div>
    -->
  </b-modal>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  props: ['branchData', 'page'],
  components: { IdxCard },

  data: () => ({
    userAuth: null,
    dailyInput: null,
    weeklyInput: null,
    monthlyInput: null,
    annuallyInput: null,
    dailyLoading: true,
    weeklyLoading: true,
    monthlyLoading: true,
    annuallyLoading: true,
    dailyEmails: [],
    weeklyEmails: [],
    monthlyEmails: [],
    annuallyEmails: [],
  }),

  computed: {},

  methods: {
    async registerEmail(type, email, input) {
      if (input) {
        if (type === 'daily') {
          this.dailyLoading = true;
          this.dailyInput = null;
        } else if (type === 'weekly') {
          this.weeklyLoading = true;
          this.weeklyInput = null;
        } else if (type === 'monthly') {
          this.monthlyLoading = true;
          this.monthlyInput = null;
        } else {
          this.annuallyLoading = true;
          this.annuallyInput = null;
        }

        try {
          await api.post(
            `branch-bulletin/${this.userAuth.companyId}/branches/${this.branchData.branchId}`,
            {
              type,
              emails: [email],
            },
            { headers: { 'x-access-token': this.userAuth.token } },
          );
          this.getEmails();
        } catch (error) {
          window.console.log(error);
        }

        this.dailyLoading = false;
        this.weeklyLoading = false;
        this.monthlyLoading = false;
        this.annuallyLoading = false;
      }
    },

    async sendUpdate() {
      EventBus.$emit('updateBranchBulletinList', true);
    },

    async remove(type, email) {
      try {
        const { data } = await api.delete(
          `branch-bulletin/${this.userAuth.companyId}/branches/${this.branchData.branchId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            data: {
              emails: [email],
              type,
            },
          },
        );
        this.dailyEmails = data.daily;
        this.weeklyEmails = data.weekly;
        this.monthlyEmails = data.monthly;
        this.annualyEmails = data.annualy;
      } catch (error) {
        window.console.log(error);
      }
    },
    async getEmails() {
      try {
        const { data } = await api.get(
          `branch-bulletin/${this.userAuth.companyId}/branches/${this.branchData.branchId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );
        this.dailyEmails = data.daily;
        this.weeklyEmails = data.weekly;
        this.monthlyEmails = data.monthly;
        this.annualyEmails = data.annualy;
      } catch (error) {
        window.console.log(error);
      }
      this.dailyLoading = false;
      this.weeklyLoading = false;
      this.monthlyLoading = false;
      this.annuallyLoading = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    await this.getEmails();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.input-area {
  display: flex;
  flex-direction: row;
}

.chip {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: $gray;
  border: 1px solid $white;
  color: $white;
  display: flex;
  align-items: center;
}

.closebtn {
  padding-left: 10px;
  color: $white;
  font-weight: bold;
  float: right;
  font-size: 15px;
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/bulletins/branch-bulletin/modal-branch-bulletin-edit.vue